module.exports = __webpack_public_path__ + "static/media/suv.12478cc4.svg";